import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { convertSearchKeywordsDataToCsv } from "./utils";
import { useOrganization } from "../../../../hooks/queries";
import {
  buildCsvFilename,
  downloadCsv,
  insertIdColumnInCsv,
} from "../../../../utils/csvUtils";
import { LocationKeywordData } from "../types";

import "./styles.scss";

export interface IDownloadCsvButtonsProps {
  data: LocationKeywordData[];
  dateFrom: dayjs.Dayjs;
  dateTo: dayjs.Dayjs;
  organizationId?: string | number;
  locationId?: string | number;
  facilityName?: string;
}

export const DownloadCsvButtons: React.FC<IDownloadCsvButtonsProps> = ({
  data,
  dateFrom,
  dateTo,
  organizationId,
  locationId,
  facilityName,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.locationKeywordsChart.downloadCsvButtons.${key}`);

  // Query organization data if organizationId is provided
  const { data: organization } = useOrganization(organizationId);

  const handleDownloadCsv = (forWindows: boolean) => {
    // Generate CSV content
    let csvContent = convertSearchKeywordsDataToCsv(data, dateFrom, dateTo);

    // Insert Facility ID column before Facility Name (location_name)
    if (locationId && data.length > 0) {
      // Build a mapping from location_name to location_id
      const facilityMapping = new Map<string, string | number>();
      data.forEach((item) => {
        if (item.location_name && item.location_id) {
          facilityMapping.set(item.location_name, item.location_id);
        }
      });

      const csvString = csvContent.join("\n");
      const modifiedCsv = insertIdColumnInCsv(
        csvString,
        "location_name",
        "Facility ID",
        facilityMapping
      );
      csvContent = modifiedCsv.split("\n");
    }

    // Build filename using the new standardized format
    const filename = buildCsvFilename(
      {
        startDate: dateFrom.format("YYYY-MM-DD"),
        endDate: dateTo.format("YYYY-MM-DD"),
        organizationName: organization?.name,
        organizationId: organizationId,
        facilityName: facilityName,
        facilityId: locationId,
        contentDescription: _t("csvFilename.search_keywords"),
      },
      _t
    );

    downloadCsv(csvContent, filename, forWindows);
  };

  return (
    <>
      <button
        className="btn btn-border"
        onClick={() => handleDownloadCsv(false)}
      >
        {t("download_utf8")}
      </button>
      <button
        className="btn btn-border"
        onClick={() => handleDownloadCsv(true)}
      >
        {t("download_shift_jis")}
      </button>
    </>
  );
};
